/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CartConfigShipping model module.
 * @module model/CartConfigShipping
 * @version v1
 */
export class CartConfigShipping {
  /**
   * Constructs a new <code>CartConfigShipping</code>.
   * @alias module:model/CartConfigShipping
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CartConfigShipping</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CartConfigShipping} obj Optional instance to populate.
   * @return {module:model/CartConfigShipping} The populated <code>CartConfigShipping</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CartConfigShipping();
      if (data.hasOwnProperty('options'))
        obj.options = ApiClient.convertToType(data['options'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} options
 */
CartConfigShipping.prototype.options = undefined;

